import * as Sentry from '@sentry/react';
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom';
import { useEffect } from 'react';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
        // Performance: tracks page loads, route changes, and web vitals
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        // Session Replay: records DOM for error reproduction
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
        // Breadcrumbs: auto-captures console, clicks, navigation, fetch/XHR
        Sentry.breadcrumbsIntegration({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            xhr: true,
        }),
        // HTTP client errors: captures 4xx/5xx from fetch/XHR as Sentry events
        Sentry.httpClientIntegration(),
        // Captures unhandled promise rejections and global errors
        Sentry.globalHandlersIntegration({
            onerror: true,
            onunhandledrejection: true,
        }),
        // Deduplicates identical events
        Sentry.dedupeIntegration(),
        // Links errors to the function/module that caused them
        Sentry.functionToStringIntegration(),
        // Reports browser, OS, device context
        Sentry.browserApiErrorsIntegration(),
    ],

    // Performance: capture 100% of transactions
    tracesSampleRate: 1.0,

    // Session Replay: 10% of sessions, 100% of sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // HTTP client: report 4xx and 5xx responses as errors
    sendDefaultPii: true,

    // Release health: track sessions for crash-free rate
    autoSessionTracking: true,

    // Filter out noisy errors
    ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        'Non-Error promise rejection captured',
    ],

    // Only send events from your domain
    allowUrls: [
        /https?:\/\/(.*\.)?turkish4love\.com/,
    ],
});
